<template>
  <div>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-top">
            <div class="table-page-search-wrapper table-page-search-header">
              <!-- 搜索区域 -->
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :span="6">
                    <a-form-item
                      label="Near地址"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-input
                        placeholder="Near地址"
                        v-model="queryParam.accountId"
                        allow-clear
                        @input="inputSearchQuery"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item
                      label="交易筆數"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-input-group>
                        <a-input
                          placeholder="上限"
                          v-model="queryParam.upper"
                          allow-clear
                          @input="inputSearchQuery"
                          style="width: 50%"
                        />
                        <a-input
                          placeholder="下限"
                          v-model="queryParam.lower"
                          allow-clear
                          @input="inputSearchQuery"
                          style="width: 50%"
                        />
                      </a-input-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item
                      label="時間篩選"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 10, offset: 1 }"
                    >
                      <a-range-picker
                        :value-format="dateFormat"
                        v-model="completeTime"
                        :ranges="ranges"
                      >
                      </a-range-picker>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <div class="table-page-search">
              <div class="button-onditions">
                <a-button icon="search" type="primary" @click="searchQuery"
                  >查詢</a-button
                >
                <!-- <a-button icon="sync" @click="searchReset">重置</a-button> -->
              </div>
            </div>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button
              type="primary"
              icon="download"
              @click="handleExportXls('交易排行清單')"
              :loading="exportLoading"
              id="export"
              >導出</a-button
            >
          </div>
          <div class="table-operator" style="margin-top: 5px">
            <a-button
              type="primary"
              icon="download"
              @click="handleExportXls('交易高级排行清單','/orderlyTrade/rankHighExport')"
              :loading="exportLoading"
              id="export"
              >高级導出排行</a-button
            >
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              @change="handleTableChange"
              class="table_info"
              :scroll="{ x: scrollX }"
            >
              <!-- <span slot="action" slot-scope="text, record">
                      <a-tag
                        color="#87d068"
                        v-if="btnEnableList.indexOf(1) > -1"
                        @click="handleEdit(record)"
                        >编辑</a-tag
                      >
                      <a-popconfirm
                        v-if="btnEnableList.indexOf(1) > -1"
                        title="确定删除吗?"
                        @confirm="() => handleDelete(record.id)"
                      >
                        <a-tag color="#f50">删除</a-tag>
                      </a-popconfirm>
                    </span> -->
            </a-table>
          </div>
          <!-- table区域-end -->
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
import { AdapterTableMixin } from "@/mixins/AdapterTableMixin";
import { downFile, postAction } from "@/api/manage";
import moment from "moment";

export default {
  name: "orderRankList",
  mixins: [JeecgListMixin, AdapterTableMixin],
  components: {},
  data() {
    return {
      // 查询条件
      queryParam: {},
      // 员工
      staffList: [],
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "",
          width: 40,
          align: "center",
          customRender(t, r, index) {
            return parseInt(index) + 1;
          },
        },
        {
          title: "Near地址",
          align: "center",
          width: 300,
          dataIndex: "address",
        },
        {
          title: "交易筆數",
          align: "center",
          width: 200,
          dataIndex: "transactions",
        },
        // {
        //   title: "操作",
        //   dataIndex: "action",
        //   align: "center",
        //   scopedSlots: { customRender: "action" },
        // },
      ],
      url: {
        list: "/orderlyTrade/rankByTxs",
        exportXlsUrl: "/orderlyTrade/rankExport",
        // exportHighXlsUrl: "/orderlyTrade/rankHighExport",

      },
      dateFormat: "YYYY-MM-DD",
      completeTime: [],
      exportLoading: false,
      ranges: {
        本周: [
          moment().startOf("week"),
          moment().endOf("week").subtract(0, "days"),
        ],
        本月: [moment().startOf("month"), moment().endOf("month")],
        本季度: [
          moment().startOf("quarter"),
          moment().endOf("quarter").subtract(0, "days"),
        ],
        本年: [moment().startOf("year"), moment().endOf("year")],
      },
    };
  },
  computed: {},
  created() {},
  methods: {
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "编辑";
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true;
      }
    },
    handleExportXls(fileName, url) {
      if (this.exportLoading) {
        this.$message.warning("其他文件正在导出，请稍后再试！");
        return false;
      }
      let exportXlsUrl;
      if (url) {
        exportXlsUrl = url;
      } else {
        exportXlsUrl = this.url.exportXlsUrl;
      }

      this.exportLoading = true;
      if (!fileName || typeof fileName != "string") {
        fileName = "导出文件";
      }
      let param = { ...this.queryParam };
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param["ids"] = this.selectedRowKeys.join(",");
      }
      downFile(exportXlsUrl, param).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          this.exportLoading = false;
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
          this.exportLoading = false;
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.exportLoading = false;
        }
      });
    },
  },
  watch: {
    completeTime: {
      handler(val, oldVal) {
        if (val.length > 0) {
          let start = new Date(val[0] + " 00:00:00").getTime();
          let end = new Date(val[1] + " 23:59:59").getTime();
          this.$set(this.queryParam, "startTime", start);
          this.$set(this.queryParam, "endTime", end);
        } else {
          delete this.queryParam.startTime;
          delete this.queryParam.endTime;
        }
        this.searchQuery();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
@import "~@assets/less/common.less";
@import "~@assets/less/button.less";
@import "~@assets/less/TaskProcess.less";
.table_info ::v-deep .ant-table-tbody > tr > td {
  padding: 5px 8px !important;
  overflow-wrap: break-word;
  font-weight: 500;
}
</style>
